<!-- Height is measured, not a vh guess — see cardHeight in the component. -->
<div class="card d-flex flex-column mt-4 monitoring-card" [style.height.px]="cardHeight()">

    <!-- Header — same shape as the synchronization detail page -->
    <div class="card-header d-flex justify-content-between align-items-center flex-shrink-0">
        <div class="fw-bold">
            Alle Synkroniseringer for {{ departmentName() }}
        </div>
    </div>

    <!-- Subsection — the scope the browser below is given -->
    <div class="card-header flex-shrink-0">
        <div class="d-flex flex-wrap align-items-end gap-3">
            <div class="filter-field">
                <label class="form-label mb-1 small text-secondary" for="mon-customer">Kunde</label>
                <select id="mon-customer" class="form-select form-select-sm"
                    [value]="customerFilter() ?? ''"
                    (change)="onCustomerFilterChange($any($event.target).value)">
                    <option value="">Alle kunder</option>
                    @for (customer of customers(); track customer.customerId) {
                        <option [value]="customer.customerId">
                            {{ customer.customerId }} — {{ customer.customerName }}
                        </option>
                    }
                </select>
            </div>

            <div class="filter-field">
                <label class="form-label mb-1 small text-secondary" for="mon-sync">Synkronisering</label>
                <select id="mon-sync" class="form-select form-select-sm"
                    [value]="synchronizationFilter() ?? ''"
                    (change)="onSynchronizationFilterChange($any($event.target).value)">
                    <option value="">Alle synkroniseringer</option>
                    @for (sync of availableSynchronizations(); track sync.id) {
                        <option [value]="sync.id">{{ sync.label }}</option>
                    }
                </select>
            </div>

            @if (hasPageFilter()) {
                <button type="button" class="btn btn-sm btn-link text-decoration-none px-1"
                    (click)="clearPageFilters()">
                    <i class="fa-solid fa-xmark me-1" aria-hidden="true"></i> Ryd filtre
                </button>
            }
        </div>
    </div>

    <!-- Body — the shared two-pane browser -->
    <div class="card-body d-flex flex-grow-1 overflow-hidden monitoring-panes">
        <app-queue-request-browser
            [customerId]="customerFilter()"
            [synchronizationId]="synchronizationFilter()" />
    </div>
</div>
